<div class="cart-profile-button primary-color" [ngClass]="{'uk-background-muted': isHovering }" (mouseover)="isHovering = true" (mouseleave)="isHovering = false">
  <i class="material-icons">
    {{icon}}
  </i>
  <div class="text">
    <h4>{{ title }}</h4>
    <h5>{{ cartCount > 9 ? '9+' : cartCount}} {{subtitle}}</h5>
  </div>
</div>
